import { Component, Input, OnInit } from '@angular/core';
import { SubTitleWrapper, User } from 'src/app/classes';

@Component({
  selector: 'app-user-preview',
  templateUrl: './user-preview.component.html',
  styleUrls: ['./user-preview.component.css']
})
export class UserPreviewComponent implements OnInit {

  preview: string;
  subTitles: SubTitleWrapper[];

  _user: User;
  @Input() set user(user: User){
    this._user = user;
    var preview = "";
    let subTitles: SubTitleWrapper[] = [];
    if(user){
      if(user.userName) preview += user.userName;
      if(user.initials) subTitles.push({ value: user.initials, type: "Initialien" } as SubTitleWrapper);
    }
    this.preview = preview;
    this.subTitles = subTitles;
  }
  get user(): User {
    return this._user;
  }

  constructor() { }

  ngOnInit(): void {
  }

}
